/* loaded by smart-asset */
export default require("./check-circle-solid~LCIKSsNa.svg")